var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/components/Drawer/Mobile/index.js",
  _this = this;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Sheet } from '@wds/sheet';
import { IconMenu, IconX } from '@wds/icons';
import useMobileDrawerStyles from './useMobileDrawerTriggerStyles';
export var MobileDrawer = function MobileDrawer(_ref) {
  var menuColor = _ref.menuColor,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    drawerOpen = _useState2[0],
    setOpen = _useState2[1];
  var toggleDrawer = function toggleDrawer() {
    return setOpen(!drawerOpen);
  };
  var _useMobileDrawerStyle = useMobileDrawerStyles(),
    MobileTrigger = _useMobileDrawerStyle.MobileTrigger;
  var buttonClass = "".concat(MobileTrigger, " sm-mobile-menu__cta sm-mobile-menu--").concat(menuColor);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    className: buttonClass,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "sm",
    onClick: toggleDrawer,
    "data-testid": "Mobile-Trigger",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }, drawerOpen ? /*#__PURE__*/React.createElement(IconX, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 25
    }
  }) : /*#__PURE__*/React.createElement(IconMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 37
    }
  }))), /*#__PURE__*/React.createElement(Sheet, {
    show: drawerOpen,
    onClose: toggleDrawer,
    placement: "left",
    offsetTop: 50,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }, children));
};
MobileDrawer.propTypes = {
  menuColor: PropTypes.oneOf(['alt', 'secondary']),
  children: PropTypes.node.isRequired
};
MobileDrawer.defaultProps = {
  menuColor: 'alt'
};
export default MobileDrawer;
//# sourceMappingURL=index.js.map